import Icon from 'veui/components/Icon'
import { IconArrowRightSolid } from 'dls-icons-vue'

Icon.register('arrow-right-solid', IconArrowRightSolid)
